import { render, staticRenderFns } from "./scatter.vue?vue&type=template&id=41743ff8&scoped=true&"
import script from "./scatter.vue?vue&type=script&lang=js&"
export * from "./scatter.vue?vue&type=script&lang=js&"
import style0 from "./scatter.vue?vue&type=style&index=0&id=41743ff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41743ff8",
  null
  
)

export default component.exports